import "../scss/main.scss";
import {
    documentToHtmlString
} from "@contentful/rich-text-html-renderer";

(function() {
    "use strict";

    var client = contentful.createClient({
        space: "jube0wy02yfl",
        accessToken: "Iq3Df-3OX8uKjLQECjs6GgzD27dRjcV6Yk25N3MxQoI",
    });

    client
        .getEntry("5cDDR0wzvEmHruKN6eNEIE", {
            include: 3
        })
        .then(function(entry) {
            document.title = entry.fields.internalName;
            // console.log(entry);

            // Integration with sections
            displayHeader(entry);
            displayGridImages(entry, "image-container")
            window.addEventListener("load", () => displayGridImages(entry, "image-container"));
            window.addEventListener("resize", () => updateImages(entry, "image-container"));
        });

    client
        .getEntry("6iJy0DMyDARxijER8UvJgY", {
            include: 3
        })
        .then(function(entryFooter) {
            displayFooter(entryFooter);
        });

    // Function to construct html header
    function displayHeader(entry) {
        document.title = "VML Well"
        const headerLogoDiv = document.querySelector(".main-header");
        if (headerLogoDiv) {
            // Crear la imagen
            const logoImg = document.createElement("img");
            logoImg.src = "./img/logo-vmwell.jpeg";
            logoImg.alt = "Logo";
            logoImg.classList.add("header-logo"); // Agregar una clase opcional

            // Insertar la imagen en el div del header
            headerLogoDiv.appendChild(logoImg);
        } else {
            console.error("No se encontró el elemento .main-header");
        }
    }

    function displayGridImages(entry, containerId) {
        const container = document.getElementById(containerId);
        if (!container) {
            console.error(`No se encontró el contenedor con id: ${containerId}`);
            return;
        }

        container.innerHTML = ""; // Limpiar el contenedor antes de agregar nuevas imágenes

        const isMobile = window.innerWidth <= 768;
        let mobileImages = [];
        let desktopImages = [];
        let urlMap = {};

        // Extraer las URLs de los enlaces
        Object.entries(entry.fields).forEach(([key, value]) => {
            if (key.toLowerCase().includes("url") && typeof value === "string") {
                const cleanKey = key.replace(/Url/gi, "").toLowerCase().trim();
                urlMap[cleanKey] = value;
            }
        });

        // console.log("URL Map:", urlMap); // Verificar que el mapa de URLs se construye bien

        // Asociar imágenes con sus enlaces correspondientes
        Object.entries(entry.fields).forEach(([key, value]) => {
            if (value && value.fields && value.fields.file && value.fields.file.url) {
                const imageUrl = "https:" + value.fields.file.url;
                const imageType = key.toLowerCase().trim();

                // Ajuste para encontrar la URL correcta
                let baseKey = imageType.replace(/mobile|desktop/gi, "").trim(); // Removemos mobile/desktop para buscar en urlMap
                let urlLink = urlMap[baseKey] || urlMap[imageType] || "#"; // Buscamos en el mapa

                const imageObject = {
                    src: imageUrl,
                    href: urlLink
                };

                if (imageType.includes("mobile")) {
                    mobileImages.push(imageObject);
                } else {
                    desktopImages.push(imageObject);
                }
            }
        });

        const selectedImages = isMobile ? mobileImages : desktopImages;

        if (selectedImages.length > 0) {
            selectedImages.forEach(({
                src,
                href
            }) => {
                const linkElement = document.createElement("a");
                linkElement.href = href;
                linkElement.target = "_blank";
                linkElement.rel = "noopener noreferrer";

                const imgElement = document.createElement("img");
                imgElement.src = src;
                imgElement.alt = "Imagen seleccionada";

                linkElement.appendChild(imgElement);
                container.appendChild(linkElement);
            });
        } else {
            console.warn("No se encontraron imágenes para este tamaño de pantalla.");
        }
    }

    function updateImages(entry, containerId) {
        displayGridImages(entry, containerId);
    }

    // Function to construct html footer
    function displayFooter(entryFooter) {
        const sections = entryFooter.fields;
        // console.log(sections);

        let footerFields;

        footerFields = sections;
        // console.log('Footer', footerFields);

        if (footerFields) {
            const footerContainer = document.querySelector(".footer");

            // Sub-section left
            const subSectionLeft = document.createElement("div");
            subSectionLeft.classList.add("sub-section", "sub-section-left");

            // Main Links
            const footerMainMenu = document.createElement("div");
            footerMainMenu.classList.add("footer-main-menu");

            const mainUl = document.createElement("ul");
            footerFields.mainLinks.forEach((link) => {
                const li = document.createElement("li");
                const a = document.createElement("a");
                a.href = link.fields.url;
                a.textContent = link.fields.text;
                li.appendChild(a);
                mainUl.appendChild(li);
            });
            footerMainMenu.appendChild(mainUl);
            subSectionLeft.appendChild(footerMainMenu);

            // Secondary Links
            const footerSubMenu = document.createElement("div");
            footerSubMenu.classList.add("footer-sub-menu");

            const secondaryUl = document.createElement("ul");
            footerFields.secondaryLinks.forEach((link) => {
                const li = document.createElement("li");
                const a = document.createElement("a");
                a.href = link.fields.url;
                a.textContent = link.fields.text;
                li.appendChild(a);
                secondaryUl.appendChild(li);
            });
            footerSubMenu.appendChild(secondaryUl);
            subSectionLeft.appendChild(footerSubMenu);

            // Disclaimer
            const disclaimerDiv = document.createElement("div");
            disclaimerDiv.classList.add("disclaimer");
            disclaimerDiv.innerHTML = documentToHtmlString(footerFields.disclaimer);
            subSectionLeft.appendChild(disclaimerDiv);

            // Sub-section right
            const subSectionRight = document.createElement("div");
            subSectionRight.classList.add("sub-section", "sub-section-right");

            // Social Media
            const menuConnect = document.createElement("div");
            menuConnect.classList.add("menu-connect");

            const p = document.createElement("p");
            p.textContent = footerFields.socialMediaTitle;
            menuConnect.appendChild(p);

            const socialdiv = document.createElement("div");
            socialdiv.classList.add("menu-social");
            footerFields.socialMediaItems.forEach((social) => {
                const link = document.createElement("a");
                link.href = social.fields.url;
                link.target = "_blank";
                link.rel = "noopener noreferrer";
                const img = document.createElement("img");
                img.src = social.fields.icon.fields.file.url;
                img.alt = social.fields.icon.fields.title;
                link.appendChild(img);
                socialdiv.appendChild(link);
            });
            menuConnect.appendChild(socialdiv);
            subSectionRight.appendChild(menuConnect);

            // Footer Image
            const footerBottomImgDiv = document.createElement("div");
            footerBottomImgDiv.classList.add("footer-bottom-img");

            const footerImg = document.createElement("img");
            footerImg.src = footerFields.footerImage.fields.file.url;
            footerImg.alt = footerFields.footerImage.fields.title;
            footerBottomImgDiv.appendChild(footerImg);

            subSectionRight.appendChild(footerBottomImgDiv);

            // Append sub-sections to the container
            footerContainer.appendChild(subSectionLeft);
            footerContainer.appendChild(subSectionRight);
        }
    }

})();